import React from "react";
import { SelectBox } from "devextreme-react";
import { useEffect } from "react";
import { setSubGridApiDefault } from "../../../../config/fetchApiConfig";
import { useSelector, useDispatch } from "react-redux";
import { SET_ALARMCONNECTION_EDIT } from "./../../../../redux/actions/actionTypes";
import { useTranslation } from "react-i18next";

const CentralSelectBox = ({ setValue, value }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [customValue, setCustomValue] = React.useState(null);
  const alarmConnectionState = useSelector((p) => p.AlarmConnectionReducer);

  useEffect(() => {
    if (value) {
      dispatch({
        type: SET_ALARMCONNECTION_EDIT,
        payload: { dataField: "selectedCentralId", value: value },
      });
      setCustomValue(value);
    }
  }, [value]);

  return (
    <SelectBox
      dataSource={setSubGridApiDefault(
        "Central",
        "id",
        "GetListByAccountField",
        null,
        null,
        null,
        { accountFieldId: alarmConnectionState.selectedAccountFieldId }
      )}
      displayExpr="name"
      onValueChanged={({ value }) => {
        setValue && setValue(value.id);
        setCustomValue(value.id);
        dispatch({
          type: SET_ALARMCONNECTION_EDIT,
          payload: { dataField: "selectedSbomId", value: null },
        });
        dispatch({
          type: SET_ALARMCONNECTION_EDIT,
          payload: { dataField: "selectedCentralId", value: value.id },
        });
      }}
      searchEnabled={true}
      value={customValue ?? alarmConnectionState.selectedCentralId}
      placeholder={t("selectCompany")}
    />
  );
};
export default CentralSelectBox;
